module.exports = __webpack_public_path__ + "img/ctrl-swap-root-stub-up-+.9d012a47.svg";